import { RewardScene } from '@/types';

import { useReward } from '@/contexts/reward-context';
import { VoucherIcon, ArrowRightIcon } from '@/components/svg-icons';

export const NavigationBar = () => {
	const { labels, setRewardScene, onKafkaSet } = useReward();

	const viewVouchers = () => {
		setRewardScene(RewardScene.MyVouchers);
		onKafkaSet({
			type: 3,
			action: 37
		});
	};
	
	return (
		<div 
			className="shop-voucher-button"
			data-show="false"
			onClick={viewVouchers}
		>
			<VoucherIcon />
			{labels?.lbl_RPMyVoucher}
			<ArrowRightIcon />
		</div>
	);
};